import { render, staticRenderFns } from "./quran.vue?vue&type=template&id=2a9ba7c0&"
import script from "./quran.vue?vue&type=script&lang=js&"
export * from "./quran.vue?vue&type=script&lang=js&"
import style0 from "./quran.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports